module.exports = __webpack_public_path__ + "static/media/02.ccb6b9e2.jpg";